import { timeParse } from 'd3'
import * as d3 from 'd3'
import charts from '../data/relationsData'
import { RISK_STATUS_COLOR_SCALE } from './chart-d3-utils'

export const formatPriceData = originalData => {
  const parseDate = timeParse('%Y-%m-%d')
  const filterData = originalData.filter(data => data['p_date'])
  filterData.map(d => {
    d['date'] = parseDate(d['p_date'])
    d['Price'] = d['p_price']
    d['Open'] = d['p_price_open']
    d['High'] = d['p_price_high']
    d['Low'] = d['p_price_low']
    d['Close'] = d['p_price']
    d['Volume'] = d['p_volume']
    return d
  })
  return filterData
}

export const formatEventData = originalData => {
  const parseDate = timeParse('%Y-%m-%d')
  originalData.reverse().map((d, i) => {
    d['date'] = parseDate(d['signal_date'])
    d['Date'] = d['signal_date']
    d['title'] = d['signal_overview']
    d['content'] = d['text']
    d.id = i
    return d
  })

  return originalData
}

export const formatScanChartData = originalData => {
  originalData.map(d => {
    d['date'] = new Date(d['date'])
    return d
  })
  return originalData
}

export const formatBondConvictionChartData = (originalData, dateField) => {
  originalData.map(d => {
    d['date'] = new Date(d[dateField])
    Object.keys(d).map(key => {
      if (d[key] === 'null') {
        d[key] = null
      } else if (key !== 'date') {
        d[key] = d[key] * 100
      }
    })
    return d
  })

  return originalData.filter(d => d['top_25_percentage_6m'] !== null)
}

export const formatHighConvictionChartData = (originalData, dateField) => {
  originalData.map(d => {
    d['date'] = new Date(d[dateField])
    Object.keys(d).map(key => {
      if (d[key] === 'null') {
        d[key] = null
      } else if (key !== 'date') {
        d[key] = d[key] * 100
      }
    })
    return d
  })

  return originalData.filter(d => d['holding_percentage_6m'] !== null)
}

export const formatEstimateChartData = (originalData, dateField) => {
  originalData.map(d => {
    d['date'] = new Date(d[dateField])
    Object.keys(d).map(key => {
      if (d[key] === 'null') {
        d[key] = null
      }
    })
    if (d['frequency'] === 'semi-annually' || d['frequency'] === 'quarterly') {
      d['frequency'] = 'interim'
    } else {
      d['frequency'] = 'annual'
    }
    return d
  })

  return originalData
}

export const mergeEquityPrice = (priceData, data) => {
  data.map(d => {
    for (const p of priceData) {
      if (p.p_date === d.p_date && p.p_price) {
        // TODO
        d.equity_price = p.p_price
        // d.equity_price = randomBetween(0.2,0.21)
      }
    }
  })
  return data
}

export const formatCreditData = (originalData, dateField) => {
  const parseDate = timeParse('%Y-%m-%d')
  const creditData = {
    pod: [],
    driver: [],
    impliedRating: [],
    showCreditChart: originalData && originalData.length > 0,
  }
  // fake data
  let count = 0
  const filterData = originalData.filter(data => data[dateField])
  filterData.map(data => {
    count++
    notPodNull(data.pod) &&
    notPodNull(data.peer_pod) &&
    creditData.pod.push({
      ticker: data.ticker,
      proper_name: data.proper_name,
      date: parseDate(data[dateField]),
      pod: data.pod,
      peer_pod: data.peer_pod,
      implied_rating: data.implied_rating,
      date_of_rating_change: data.date_of_rating_change,
      previous_implied_rating: data.previous_implied_rating,
      implied_rating_change: data.implied_rating_change,
      p_date: data[dateField],
      signal_data_array: data.signal_data_array,
      signal_type: data.signal_type,
      risk_outlook: data.risk_outlook,
      signal_overview: data.signal_overview,
    })

    notPodNull(data.pod) &&
    afterTime(parseDate(data[dateField]), new Date('2017-01-01')) &&
    data.implied_rating &&
    creditData.impliedRating.push({
      ticker: data.ticker,
      date: parseDate(data[dateField]),
      implied_rating: data.implied_rating,
      date_of_rating_change: data.date_of_rating_change,
      previous_implied_rating: data.previous_implied_rating,
      implied_rating_change: data.implied_rating_change,
      p_date: data[dateField],
    })

    notDriverNull(data.leverage) &&
    notDriverNull(data.asset_volatility) &&
    creditData.driver.push({
      ticker: data.ticker,
      proper_name: data.proper_name,
      date: parseDate(data[dateField]),
      leverage: data.leverage,
      asset_market_value: data.asset_market_value,
      asset_volatility: data.asset_volatility,
      // TODO - mock data
      // marketAsset: generateRandomInteger(10000000),
      // leverage: Math.random(),
      // volatility: Math.random(),
      p_date: data[dateField],
    })
  })

  return creditData
}

export const formatCreditDataCompare = (originalData, dateField) => {
  const creditData = {pod: []}
  const filterData = originalData.filter(data => data[dateField])
  filterData.map(data => {
    notPodNull(data.pod) &&
    creditData.pod.push({
      ticker: data.ticker,
      proper_name: data.proper_name,
      pod: data.pod,
      p_date: data[dateField],
    })
  })

  return creditData
}

const afterTime = (time1, time2) => {
  return time1.getTime() - time2.getTime()
}

const correctValue = data => {
  if (data === 'null') return 0
  return data
}

const notDriverNull = obj => {
  if (obj === 0 || obj === '0') return true
  if (!obj || obj === 'null') return false
  return true
}

const notPodNull = obj => {
  if (obj === 0 || obj === '0') return true
  if (!obj) return false
  // if (!obj || obj === 'null') return false
  return true
}

const generateRandomInteger = max => {
  return Math.floor(Math.random() * max) + 1
}

export const formatStackAreaChartData = originalData => {
  const temp = originalData.map(d => {
    const stackAreaKeys = Object.keys(d).filter(
      item =>
        item !== 'chart_name' && item !== 'chart_number' && item !== 'date',
    )

    Object.keys(d).map(key => {
      if (d[key] === 'null') {
        d[key] = null
      } else {
        if (d[key] < 0) {
          d[key] = 0
        }
        if (!isNaN(Number(d[key]) * 1000000)) {
          d[key] = Number(d[key]) * 1000000 // convert from millions
        }
      }
      let isNotNull = false
      let isNotZezo = false
      stackAreaKeys.forEach(k => {
        isNotNull = isNotNull || d[k] !== null
        isNotZezo = isNotZezo || d[k] !== 0
      })
      d['isNotNull'] = isNotNull
      d['isNotZezo'] = isNotZezo
    })
    return d
  })

  return temp.filter(d => d['isNotNull'] && d['isNotZezo'])
}

export const formatLineChartData = originalData => {
  const temp = originalData.map(d => {
    const lineKeys = Object.keys(d).filter(
      item =>
        item !== 'dateString' &&
        item !== 'chart_name' &&
        item !== 'chart_number' &&
        item !== 'date',
    )

    Object.keys(d).map(key => {
      if (d[key] === 'null' || d[key] === '') {
        d[key] = null
      }
    })
    let isNotNull = false
    let isNotZezo = false
    lineKeys.forEach(k => {
      isNotNull = isNotNull || d[k] !== null
      isNotZezo = isNotZezo || d[k] !== 0
    })
    d['isNotNull'] = isNotNull
    d['isNotZezo'] = isNotZezo
    return d
  })

  return temp.filter(d => d['isNotNull'] && d['isNotZezo'])
}

export const getChartName = chartId => {
  let chartName = chartId
  charts.forEach(c => {
    if (c.id === chartId) {
      chartName = c.title
    }
  })
  return chartName
}

export const getColorFromStatus = status => {
  const colorScale = RISK_STATUS_COLOR_SCALE
  return colorScale[status]
}

export const filterTickers = (tickerArrays, filterObject) => {
  const filter = {
    keyWord: filterObject.keyWord,
    bfaiRating: bfaiRating =>
      filterObject.impliedRating.length > 0
        ? filterObject.impliedRating.map(s => s.value).includes(bfaiRating)
        : true,
    risk_outlook: status =>
      filterObject.riskStatus.length > 0
        ? filterObject.riskStatus.map(s => s.value).includes(status)
        : true,
    credit_status: creditRiskStatus =>
      filterObject.creditRiskStatus.length > 0
        ? filterObject.creditRiskStatus
          .map(s => s.value)
          .includes(creditRiskStatus)
        : true,
    iso_country: iso_country =>
      filterObject.country.length > 0
        ? filterObject.country.map(c => c.id).includes(iso_country)
        : true,
    region: region =>
      filterObject.region.length > 0
        ? filterObject.region.map(r => r.value).includes(region)
        : true,
    factset_sector_desc: factset_sector_desc =>
      filterObject.sector.length > 0
        ? filterObject.sector.map(s => s.value).includes(factset_sector_desc)
        : true,
    industry: industry =>
      filterObject.industry.length > 0
        ? filterObject.industry.map(r => r.value).includes(industry)
        : true,
  }

  return filterArray(tickerArrays, filter)
}

function filterArray(array, filters) {
  const filterKeys = Object.keys(filters)
  return array
    .filter(item => {
      // validates all filter criteria
      return filterKeys.every(key => {
        if (!filters[key].length) {
          return true // passing an empty filter means that filter is ignored.
        }
        // ignores non-function predicates
        if (typeof filters[key] !== 'function') return true
        return filters[key](item[key])
      })
    })
    .filter(d => {
      return filters.keyWord
        ? `${d.proper_name}${d.ticker}`
          .toUpperCase()
          .includes(filters.keyWord.toUpperCase())
        : true
    })
}

export const impliedRatingComparator = (value1, value2) => {
  return (
    IMPLIED_RATING_LIST.indexOf(value1) - IMPLIED_RATING_LIST.indexOf(value2)
  )
}
export const IMPLIED_RATING_LIST = [
  'Uncertain',
  'CCC',
  'B',
  'BB',
  'BBB',
  'A',
  'AA',
]

export const getImpliedRatingRange = height => {
  const { length } = IMPLIED_RATING_LIST
  const unit = height / length
  const range = []
  for (let i = 0; i < length; i++) {
    range.push(unit * (i + 1))
  }
  return range.reverse()
}

export const clearD3Tips = () => {
  d3.selectAll('.d3-tip-stack-area-chart').remove()
  d3.selectAll('.d3-tip-line-chart').remove()
  d3.selectAll('.d3-tip-pod-chart').remove()
  d3.selectAll('.d3-tip-driver-chart').remove()
  d3.selectAll('.d3-tip-marble-chart').remove()
  d3.selectAll('.d3-tip-focus-chart').remove()
  d3.selectAll('.d3-tip-estimate-chart').remove()
  d3.selectAll('.d3-tip-implied-rating-chart').remove()
  d3.selectAll('.d3-tip').remove()
}

export const displayPod = pod => {
  return !pod || pod === 'null' ? '' : `${(pod * 100).toFixed(2)}%`
}

export const displayPodShow0 = pod => {
  return !pod || pod === 'null' ? '0%' : `${(pod * 100).toFixed(2)}%`
}

export const waiting = async (_timeout) => new Promise(res => setTimeout(res, _timeout));

export const INIT_FILTER_STATE = {
  impliedRating: 'Implied Rating',
  status: 'Risk Outlook',
  sector: 'Sector',
  industry: 'Industry',
  country: 'Country',
  region: 'Region',
}

export const PERCENT_CHANGE_ASSET_VOLATILITY = 0.05;
export const PERCENT_CHANGE_LEVERAGE = 0.1;

export const mappingTitleSearch = (title) =>  {
  let mappingTitle = ''
  switch (title) {
    case 'High':
      mappingTitle = 'High'
      break
    case 'Medium':
      mappingTitle = 'Medium'
      break
    case 'Low':
      mappingTitle = 'Watchlist'
      break
    case 'Fire':
      mappingTitle = 'Fire'
      break
    case 'Smoke':
      mappingTitle = 'Smoke'
      break
    case 'Watchlist':
      mappingTitle = 'Watchlist'
      break
    case 'Neutral':
      mappingTitle = 'Neutral'
      break
    default:
      mappingTitle = title
      break
  }
  return mappingTitle
}

export const mergePodCompare = (podCompareDataOld, dataAdd) => {
  let data = podCompareDataOld ?? {};
  let positionCompare = `pod_compare${(podCompareDataOld&& typeof podCompareDataOld === 'object' ? Object.keys(podCompareDataOld).length + 1 : 1)}`;
  data[positionCompare] = dataAdd;
  return data
}

export const deleteItemPodCompare = (podCompareDataOld, dataDelete) => {
  let res = {};
  if(typeof podCompareDataOld == 'object' && Object.keys(podCompareDataOld).length > 0) {
    let data = Object.values(podCompareDataOld).filter((it) => {
      if(it && it.length > 0 && it[0]?.ticker !== dataDelete.ticker) {
        return true;
      }
      return false;
    });

    if(data.length > 0) {
      data.forEach((it, key) => {
        let positionCompare = `pod_compare${key + 1}`;
        res[positionCompare] = it;
      })
    }
  }
  return res;
}
export const mergePodCompareToPod = (data, dataCompare) => {
  if(typeof dataCompare == 'object' && Object.keys(dataCompare).length > 0) {
    data.map(d => {
      if (Object.keys(dataCompare).includes('pod_compare1') && !d?.pod_compare1) {
        for (const p1 of dataCompare['pod_compare1']) {
          if (p1.p_date === d.p_date) {
            // TODO
            d['pod_compare1'] = p1.pod
            d['pod_compare1_name'] = p1.proper_name
          }
        }
      }
      if (Object.keys(dataCompare).includes('pod_compare2') && !d?.pod_compare2) {
        for (const p2 of dataCompare['pod_compare2']) {
          if (p2.p_date === d.p_date) {
            // TODO
            d['pod_compare2'] = p2.pod
            d['pod_compare2_name'] = p2.proper_name
          }
        }
      }
      if (Object.keys(dataCompare).includes('pod_compare3') && !d?.pod_compare3) {
        for (const p3 of dataCompare['pod_compare3']) {
          if (p3.p_date === d.p_date) {
            // TODO
            d['pod_compare3'] = p3.pod
            d['pod_compare3_name'] = p3.proper_name
          }
        }
      }
    })
  }
  return data
}

export  const compareGetMin = (min1, min2) => {
  if(min1 > min2) {
    return min2;
  }
  return min1
}

export  const compareGetMax = (max1, max2) => {
  if(max1 < max2) {
    return max2;
  }
  return max1;
}

export const sliceStringWithChar = (val) => {
  let indexLast  = val?.lastIndexOf("/");
  if(indexLast) {
    const textLine1 = val?.slice(0, indexLast + 1);
    const textLine2 = val?.slice(indexLast + 1);

    return textLine1 + "\n" + textLine2;
  } else {
    return val
  }
}